import React, { useRef, useEffect } from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import styles from './styles.module.scss';

interface LayoutProps {
  children: React.ReactNode;
  showNavbar?: boolean;
  showFooter?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  showNavbar = true, 
  showFooter = true
}) => {
  const footerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (footerRef.current) {
        const footerRect = footerRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const offset = 150; // Adjust this value as needed

        // Add/remove class to body when footer is visible
        if (footerRect.top < windowHeight + offset) {
          document.body.classList.add('footer-visible');
        } else {
          document.body.classList.remove('footer-visible');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.classList.remove('footer-visible'); // Cleanup
    };
  }, []);

  return (
    <div className={`${styles.layout} ${!showNavbar && !showFooter ? styles.layoutAuth : ''}`}>
      {showNavbar && <Navbar />}
      <main className={`${styles.main} ${!showNavbar && !showFooter ? styles.mainAuth : ''}`}>
        {React.isValidElement(children) 
          ? React.cloneElement(children, { footerRef } as any)
          : children
        }
      </main>
      {showFooter && <Footer ref={footerRef} />}
    </div>
  );
};

export default Layout;